import { DpdProductVariant } from "../dpd-product/dpd-product-variant"
import { ICreateParcelModel } from "../i-create-parcel-model"
import { CreateParcelModelExtension } from "./create-parcel-model-extension"
import * as _ from "lodash"
import { DpdProductVariantExtension } from "../dpd-product/dpd-product-variant-extension"
import { CreateParcelModel } from "../create-parcel-model"

export class CreateParcelModelExtensions {
  private readonly createParcelModel: CreateParcelModel

  readonly cashOnDelivery: CreateParcelModelExtension
  readonly returnParcel: CreateParcelModelExtension
  readonly exchange: CreateParcelModelExtension
  readonly saturdayDelivery: CreateParcelModelExtension
  readonly parcelShop: CreateParcelModelExtension
  readonly sameDay: CreateParcelModelExtension
  readonly document: CreateParcelModelExtension
  readonly b2c: CreateParcelModelExtension
  readonly food: CreateParcelModelExtension
  readonly sfs: CreateParcelModelExtension

  readonly createParcelModelExtensions: CreateParcelModelExtension[] = []

  constructor(createParcelModel?: CreateParcelModel) {
    this.createParcelModel = createParcelModel

    this.saturdayDelivery = new CreateParcelModelExtension(this.createParcelModel, "saturdayDelivery")
    this.returnParcel = new CreateParcelModelExtension(this.createParcelModel, "returnParcel")
    this.cashOnDelivery = new CreateParcelModelExtension(this.createParcelModel, "cashOnDelivery")
    this.exchange = new CreateParcelModelExtension(this.createParcelModel, "exchange")
    this.parcelShop = new CreateParcelModelExtension(this.createParcelModel, "parcelShop")
    this.sameDay = new CreateParcelModelExtension(this.createParcelModel, "sameDay")
    this.document = new CreateParcelModelExtension(this.createParcelModel, "document")
    this.b2c = new CreateParcelModelExtension(this.createParcelModel, "b2c")
    this.food = new CreateParcelModelExtension(this.createParcelModel, "food")
    this.sfs = new CreateParcelModelExtension(this.createParcelModel, "shipFromShop")


    this.createParcelModelExtensions.push(
      this.saturdayDelivery,
      this.returnParcel,
      this.cashOnDelivery,
      this.exchange,
      this.parcelShop,
      this.sameDay,
      this.document,
      this.b2c,
      this.food,
      this.sfs
    )
  }

  initProductExtensions(dpdProductVariant: DpdProductVariant) {
    _.forEach(this.createParcelModelExtensions, createParcelModelExtension => {
      createParcelModelExtension.enabled = dpdProductVariant[createParcelModelExtension.name]
      if (createParcelModelExtension.name === "shipFromShop") {
        createParcelModelExtension._value = createParcelModelExtension.enabled
      }
      if ((dpdProductVariant.productType === "DPD_HOME"
        || dpdProductVariant.productType === "DPD_SHOP"
        || dpdProductVariant.productType === "DPD_SHOP_2_HOME")
        && createParcelModelExtension.name === "b2c") {
        createParcelModelExtension._value = true
      }
    })

    const checked = _.chain(this.createParcelModelExtensions)
      .filter(createParcelModelExtension => createParcelModelExtension.value)
      .reduce((accumulator: CreateParcelModelExtension[], value) => {
        accumulator.push(value)
        return accumulator
      }, [])
      .value()

    const unchecked = _.chain(this.createParcelModelExtensions)
      .filter(createParcelModelExtension => !createParcelModelExtension.value)
      .reduce((accumulator: CreateParcelModelExtension[], value) => {
        accumulator.push(value)
        return accumulator
      }, [])
      .value()
    _.forEach(checked, createParcelModelExtension => {
      const dpdProductVariantsWithCorrespondingExtensionDisabled = _.filter(
        this.createParcelModel._dpdProductVariants,
        innerDpdProductVariant => {
          const variantExtension: DpdProductVariantExtension = innerDpdProductVariant[createParcelModelExtension.name]
          return !variantExtension
        }
      )

      createParcelModelExtension.enabled = !_.isEmpty(dpdProductVariantsWithCorrespondingExtensionDisabled)
    })

    const strictSupersetDpdProductVariants = _.filter(
      this.createParcelModel._dpdProductVariants,
      innerDpdProductVariant => innerDpdProductVariant.isStrictSubset(dpdProductVariant)
    )


    _.forEach(unchecked, createParcelModelExtension => {
      const supersetDpdProductVariantsWithCorrespondingExtensionEnabled: any = _.filter(
        strictSupersetDpdProductVariants,
        (dpdProductVariant1: DpdProductVariant) => {
          const dpdProductVariantExtension: DpdProductVariantExtension = (dpdProductVariant1 as any)[
            createParcelModelExtension.name
          ]

          return dpdProductVariantExtension
        }
      )

      if (supersetDpdProductVariantsWithCorrespondingExtensionEnabled.length === 0 ) {
        createParcelModelExtension.enabled = this.createParcelModel.dpdProductVariant[createParcelModelExtension.name]
      } else {
        createParcelModelExtension.enabled = !_.isEmpty(supersetDpdProductVariantsWithCorrespondingExtensionEnabled)
      }
    })
  }

  get binary(): number {
    return _.reduce(
      this.createParcelModelExtensions,
      (accumulator, createParcelModelExtension) => {
        let result = accumulator.result
        result <<= 1
        if (createParcelModelExtension.value) {
          result |= 1
        }
        return { result }
      },
      { result: 0 }
    ).result
  }

  get context(): any {
    return _.reduce(
      this.createParcelModelExtensions,
      (accumulator, createParcelModelExtension) => {
        accumulator[createParcelModelExtension.name] = createParcelModelExtension.value
        return accumulator
      },
      {} as any
    )
  }
}
